import { isFSA } from 'flux-standard-action'
import invariant from 'invariant'
import {
  TABLE_MANAGEMENT_MAP_OPEN_ADD_TABLE,
  TABLE_MANAGEMENT_MAP_CLOSE_ADD_TABLE,
  TABLE_MANAGEMENT_MAP_OPEN_EDIT_MODAL,
  TABLE_MANAGEMENT_MAP_CLOSE_EDIT_MODAL,
  TABLE_MANAGEMENT_MAP_SET_TABLE,
  TABLE_MANAGEMENT_MAP_SET_TABLES,
  TABLE_MANAGEMENT_MAP_SET_ORIGINAL_TABLES,
  TABLE_MANAGEMENT_MAP_SHOW_DELETE_MODAL,
  TABLE_MANAGEMENT_MAP_HIDE_DELETE_MODAL,
  TABLE_MANAGEMENT_MAP_UPDATE_SAVE_LAYOUT
} from 'actions/tableManagement/constants'
import _isEqual from 'lodash/isEqual'

let initialState = {
  outlets: [],
  tables: [],
  originalTables: [],
  table: null,
  showAddTableModal: false,
  showEditTableModal: false,
  showDeleteModal: false,
  setting: {},
  isSubmittingForm: false,
  disableSaveLayoutButton: true
}

function reducer (state = initialState, action) {
  invariant(
    isFSA(action),
    `Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ${JSON.stringify(action)}`
  )
  let {payload} = action
  switch (action.type) {
    case TABLE_MANAGEMENT_MAP_OPEN_ADD_TABLE:
      return {...state, showAddTableModal: true}
    case TABLE_MANAGEMENT_MAP_CLOSE_ADD_TABLE:
      return {...state, showAddTableModal: false}
    case TABLE_MANAGEMENT_MAP_OPEN_EDIT_MODAL:
      return {...state, showEditTableModal: true}
    case TABLE_MANAGEMENT_MAP_CLOSE_EDIT_MODAL:
      return {...state, showEditTableModal: false}
    case TABLE_MANAGEMENT_MAP_SET_TABLE:
      return {...state, table: payload.table}
    case TABLE_MANAGEMENT_MAP_SET_TABLES:
      return {...state, tables: payload.tables}
    case TABLE_MANAGEMENT_MAP_SET_ORIGINAL_TABLES:
      return {...state, originalTables: payload.originalTables}
    case TABLE_MANAGEMENT_MAP_SHOW_DELETE_MODAL:
      return {...state, showDeleteModal: true}
    case TABLE_MANAGEMENT_MAP_HIDE_DELETE_MODAL:
      return {...state, showDeleteModal: false}
    case TABLE_MANAGEMENT_MAP_UPDATE_SAVE_LAYOUT:
      return {...state, disableSaveLayoutButton: _isEqual(payload.tables, payload.originalTables)}
    default:
      return {...state}
  }
}

export default reducer



// WEBPACK FOOTER //
// ./app/reducers/tableManagement/map.js